import Vue from 'vue'
import Router from 'vue-router'
import Faq from './views/Faq.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      alias: '/'
    }
  ]
})
